// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1IOh5","content":"GlobalSearch_content__23401"};